
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { environment } from '../../../environments/environment';
import { User } from '../../shared/models/user.model';

import { ErrorMessagesConstants } from '../../shared/constants/error-messages-constants';
import { EngagementService } from '../../core/services/engagement/engagement.service';
import { UserService } from '../../core/services/user/user.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    CommonModule,
  ]
})
export class HomeComponent implements OnInit, OnDestroy {
  private _breakpointObserver = inject(BreakpointObserver);
  private _userService = inject(UserService);
  engagementService = inject(EngagementService);
  message: string = 'Hello, ';
  currentUserName!: string;
  currentUserCanAccessBudgetTool!: boolean;
  errorMsg: string = '';

  accountsUrl: string = environment.accountsUrl;
  opportunitiesUrl: string = environment.opportunitiesUrl;
  budgetsUrl: string = environment.iBudget;
  ERAUrl: string = environment.eraServer;
  iShareUrl: string = environment.iShareUrl;
  teamsUrl: string = environment.teamsUrl;
  hubUrl: string = environment.hubUrl;
  pmToolboxUrl: string = environment.pmToolboxUrl;
  drbHomeTileUrl: string = environment.drbHomeTileUrl;
  winStrategyUrl: string = environment.winStrategyUrl;
  peopleUrl: string = environment.peopleSearchUrl;
  proConnectUrl: string = environment.proConnectUrl;
  iAccessURL: string = environment.iAccessURL;
  pkicUrl: string = environment.pkicViewRequestsUrl;
  ironcladUrl: string = environment.ironcladUrl;
  displayIroncladTile: boolean = false;

  loginDisplay = false;
  token = '';

  showTeamsLink: boolean = false;
  displayIAccessTile: boolean = false;
  allowedIAccessEmployees!: number[];

  pbData!: any;
  isMobile: boolean = false;

  destroyed = new Subject<void>();

  get getAllowedIAccessEmployees() {
    const businessUnits: number[] =
      environment.allowedIAccessEmployeesBusinessUnits.map((x) => Number(x));
    return businessUnits;
  }

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    inject(BreakpointObserver)
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.isMobile = true;
        }
      });
  }

  ngOnInit() {
    this.allowedIAccessEmployees = this.getAllowedIAccessEmployees;
    this.getCurrentUser();
    this.engagementService.setMenuInactive();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        console.log(result);
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  getCurrentUser() {
    this._userService.getUser().subscribe({
      next: (user: User) => {
        if (!user) throw new Error('User data is null or undefined');
        console.log(user);
        try {
          this.showTeamsLink = user.isTeamsEnabled;
          this.displayIroncladTile = user.isDefaultBusinessUnitIroncladEnabled === true && this.ironcladUrl.trim().length > 0;
          window.localStorage.setItem('currentUserName', user.name);
          this.currentUserName = user.name;
          console.log('currentUserName', this.currentUserName);
          if (this.isEmptyName(this.currentUserName)) {
            this.currentUserName = user.name;
          }
          this.message += this.currentUserName + '!';
          this.displayIAccessTile = user.additionalBusinessUnits?.some((businessUnit) => this.allowedIAccessEmployees.includes(Number(businessUnit.name))) ?? false;
          this.currentUserCanAccessBudgetTool = user.canAccessBudgetTool;
        } catch (err) {
          console.error(err);
        }
      },
      error: (error: any) => {
        if (error != null && error.status === 403) {
          this.errorMsg =
            `${ErrorMessagesConstants.APP_MESSAGES.PERMISSION_NOT_PROVIDED}`;
          this.message = '';
        }
        throw 'get current user custom api Data Loading Error' + error;
      }
    });
  }

  isEmptyName(name: string) {
    return name == null || !name || name.length === 0;
  }
}
